import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  Paper,
  Typography,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  TextField,
  InputAdornment,
} from '@mui/material';
import { Storefront, Search } from '@mui/icons-material';

import { storesData } from "./storesData";

const HomeListStore = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  // Memoize the filtered list to avoid recalculating on every render
  const filteredStores = useMemo(() => {
    if (!searchTerm) {
      return storesData;
    }
    return storesData.filter(
      (store) =>
        store.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        store.location.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);

  const handleStoreSelect = (storeId) => {
    // Navigate to the dynamic route for the selected store
    navigate(`/${storeId}`);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <header>
        <Typography variant="h3" component="h1" fontWeight="bold" gutterBottom>
          Restaurant Menus
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Select a store to view its menu.
        </Typography>
      </header>

      <Grid container spacing={4} sx={{ mt: 2, justifyContent: 'center' }}>
        {/* Store List */}
        <Grid item xs={12} md={8} lg={6}>
          <Paper elevation={2} sx={{ p: 2, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ mb: 2, pl: 2 }}>Store Locations</Typography>
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Search stores..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 2 }}
            />
            <List component="nav">
              {filteredStores.length > 0 ? (
                filteredStores.map((store) => (
                  <ListItemButton
                    key={store.id}
                    onClick={() => handleStoreSelect(store.id)}
                    sx={{ borderRadius: 2 }}
                  >
                    <ListItemIcon>
                      <Storefront />
                    </ListItemIcon>
                    <ListItemText primary={store.name} secondary={store.location} />
                  </ListItemButton>
                ))
              ) : (
                <Typography align="center" color="text.secondary" sx={{ p: 2 }}>
                  No stores found.
                </Typography>
              )}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default HomeListStore;

